<template>
  <div class="left-menu radius-20 bg-main padding-top-50 margin-right-40 w-206 padding-bottom-30 bg-red">
    
    <div class="user-info flex align-center justify-center flex-direction">
      <img :src="currentUserInfo.avatar" class="w-78 h-78 radius-50" />
      <div class="text-white padding-top-10 text-bold">{{ currentUserInfo.username }}</div>
      <div
        class="w-61 h-26 bg-red radius-2 text-16 text-bold flex align-center justify-center margin-top-20 cursor-pointer sign-entry-button"
        :class="{ 'sign-entry-disabled': hasSignedToday }" @click="handleSignEntryClick">
        {{ hasSignedToday ? "已签到" : "签到" }}
      </div>
    </div>

    
    <div class="menu-list margin-top-30 flex align-center justify-center flex-direction">
      <div
        class="menu-item text-white flex align-center w-162 h-46 justify-center radius-10 margin-bottom-20 cursor-pointer"
        v-for="(item, index) in menuData" :key="index" :class="{ active: activeIndex === index }"
        @click="handleMenuClick(item, index)">
        <img :src="item.icon" class="w-18 h-22" />
        <span class="padding-left-12">{{ item.name }}</span>
      </div>
      <div class="text-center padding-top-85">
        <img :src="officialAccountImage" class="w-70 h-70" />
        <div class="padding-top-10 text-white">在线学习系统</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="80%" :show-close="false">
      <div class="dialog-content-wrapper">
        <div class="text-32 text-bold text-000-color padding-left-30 padding-top-30">
          每日签到
        </div>
        <div class="scroll-view scroll-y flex-sub bg-white padding-top-40">
          <div class="signin-container">
            <div class="signin-grid">
              <div v-for="(item, index) in list" :key="index" class="flex justify-center ">
                <div
                  class="flex justify-around align-center flex-direction margin-bottom-12 w-109 h-188 bg-F5 radius-16"
                  :class="signActiveIndex === index ? 'active-sty' : ''" @click="handleSignItem(item, index)">
                  <div class="text-22 padding-top-10">{{ item.name }}</div>
                  <img src="@/assets/icon24.png" class="icon-48" v-if="item.is_sign" />
                  <img src="@/assets/icon23.png" class="icon-56" v-else />
                  <div class="text-999-color text-24">+{{ item.score }}</div>
                </div>
              </div>
            </div>
            <div class="signin-button-container">
              <el-button type="primary" class="custom-button-common-long" :disabled="hasSignedToday"
                @click="doSign">签到</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { fetchContact } from '@/api/common'

export default {
  name: "LeftMenu",
  props: {
    
    userInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      activeIndex: -1,
      signActiveIndex: -1,
      list: [],
      day: '',
      officialAccountImage: require("@/assets/bg.png"), 
      
      menuData: [
        {
          name: "个人中心",
          icon: require("@/assets/icon7.png"),
          path: "/profile",
        },
        {
          name: "学习记录",
          icon: require("@/assets/icon8.png"),
          path: "/records",
        },
        {
          name: "学习时长",
          icon: require("@/assets/icon9.png"),
          path: "/duration",
        },
        {
          name: "修改密码",
          icon: require("@/assets/icon10.png"),
          path: "/change-password",
        },
        {
          name: "退出登录",
          icon: require("@/assets/icon11.png"),
          path: "/logout",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      storeUserInfo: state => state.userInfo,
    }),
    ...mapGetters(['getUserInfo']),
    mergedUserInfo() {
      let localUserInfo = {};
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        try {
          localUserInfo = JSON.parse(userInfoStr) || {};
        } catch (e) {
          console.error('Failed to parse userInfo from storage in LeftMenu', e);
        }
      }
      return {
        username: '学生名称',
        avatar: require("@/assets/icon1.png"),
        isSignedIn: false,
        ...localUserInfo,
        ...(this.userInfo || {}),
        ...(this.storeUserInfo || {}),
      };
    },
    hasSignedToday() {
      const flag = this.mergedUserInfo?.day_is_sign;
      if (flag === undefined || flag === null) {
        return !!this.mergedUserInfo?.isSignedIn;
      }
      if (typeof flag === 'string') {
        return flag === '1' || flag.toLowerCase() === 'true';
      }
      if (typeof flag === 'number') {
        return flag === 1;
      }
      return !!flag;
    },
    
    todayDateString() {
      const now = new Date();
      const year = now.getFullYear();
      const month = `${now.getMonth() + 1}`.padStart(2, "0");
      const day = `${now.getDate()}`.padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    
    currentUserInfo() {
      return {
        username: this.mergedUserInfo.nickname || this.mergedUserInfo.username || '学生名称',
        avatar: this.mergedUserInfo.avatar || require("@/assets/icon1.png"),
        isSignedIn: this.hasSignedToday,
        day_is_sign: this.mergedUserInfo.day_is_sign,
      };
    },
  },
  created() {
    
    if (localStorage.getItem("isLoggedIn")) {
      
      const vuexUserInfo = this.$store.state.userInfo;
      if (!vuexUserInfo || (!vuexUserInfo.username && !vuexUserInfo.nickname)) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            this.$store.commit('SET_USER_INFO', userInfo);
          } catch (e) {
            console.error('Failed to parse userInfo', e);
          }
        }
      }
    }
  },
  mounted() {
    this.updateActiveIndex();
    
    if (localStorage.getItem("isLoggedIn")) {
      const vuexUserInfo = this.$store.state.userInfo;
      if (!vuexUserInfo || (!vuexUserInfo.username && !vuexUserInfo.nickname)) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            this.$store.commit('SET_USER_INFO', userInfo);
          } catch (e) {
            console.error('Failed to parse userInfo in mounted', e);
          }
        }
      }
    }
    
    this.loadContactInfo();
  },
  watch: {
    $route(to, from) {
      
      if (to.path === "/logout") {
        this.activeIndex = -1;
        return;
      }
      this.updateActiveIndex();
    },
    
    storeUserInfo: {
      handler(newVal) {
        
        
        if (newVal && (newVal.username || newVal.nickname)) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
      immediate: true
    },
    
    '$store.state.userInfo': {
      handler(newVal) {
        if (newVal && (newVal.username || newVal.nickname)) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions(['fetchUserInfo', 'updateUserInfo', 'clearUserInfo']),
    handleSignEntryClick() {
      this.loadSignList();
    },
    
    loadContactInfo() {
      fetchContact()
        .then((res) => {
          if (res.data && res.data.official_account) {
            this.officialAccountImage = res.data.official_account;
          }
        });
    },
    
    loadSignList() {
      import('@/api/common').then(({ getSignList }) => {
        getSignList().then((res) => {
          this.list = res.data;
          if (res.data.length) {
            this.dialogVisible = true;
          }
        });
      });
    },
    
    doSign() {
      if (this.hasSignedToday) {
        this.$message.info("今日已签到，无法重复签到");
        return;
      }
      if (!this.day) {
        this.$message.warning("请先选择签到日期");
        return;
      }
      const selectedItem = this.list.find(item => item.date === this.day);
      if (!this.canSignItem(selectedItem)) {
        this.$message.warning("仅可签到今日且尚未签到的日期");
        return;
      }
      import('@/api/common').then(({ doSign }) => {
        doSign(this.day).then((res) => {
          this.$message.success("签到成功！");
          this.dialogVisible = false;
          this.loadSignList();
          const updatedInfo = { day_is_sign: 1, isSignedIn: true };
          this.updateUserInfo(updatedInfo);
          try {
            const storedUserInfo = localStorage.getItem('userInfo');
            const parsedInfo = storedUserInfo ? JSON.parse(storedUserInfo) : {};
            const mergedInfo = { ...parsedInfo, ...updatedInfo };
            localStorage.setItem('userInfo', JSON.stringify(mergedInfo));
          } catch (e) {
            console.error('Failed to update userInfo in storage after sign', e);
          }
        });
      });
    },
    
    updateActiveIndex() {
      const currentPath = this.$route.path;
      
      if (currentPath === "/logout") {
        this.activeIndex = -1;
        return;
      }
      const activeItem = this.menuData.find(item => item.path === currentPath);
      if (activeItem) {
        this.activeIndex = this.menuData.indexOf(activeItem);
      } else {
        this.activeIndex = -1;
      }
    },
    
    handleSignIn() {

      
      
      
    },

    canSignItem(item) {
      if (!item || !item.date) {
        return false;
      }
      const dateMatchesToday = item.date === this.todayDateString;
      const notSignedYet = this.mergedUserInfo?.day_is_sign === 0 || this.mergedUserInfo?.day_is_sign === '0';
      return dateMatchesToday && notSignedYet;
    },

    
    handleSignItem(item, index) {
      if (!this.canSignItem(item)) {
        this.$message.warning("仅可选择今天且未签到的日期");
        return;
      }
      this.signActiveIndex = index;
      this.day = item.date;
    },
    
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          
          this.$bus.$emit('user-logout');

          
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("token");
          localStorage.removeItem("need-review");

          
          this.clearUserInfo();

          
          this.$emit("logout");

          
          this.$router.push("/login");

          this.$message.success("退出登录成功！");
        })
        .catch(() => {
          
        });
    },
    
    handleMenuClick(item, index) {
      this.activeIndex = index;
      if (item.path === "/logout") {
        this.handleLogout();
      } else {
        if (this.$route.path !== item.path) {
          this.$router.push(item.path);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.left-menu {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}


@media (min-width: 768px) and (max-width: 1440px) {
  .left-menu {
    .padding-top-50 {
      padding-top: 35px !important;
    }

    .padding-bottom-30 {
      padding-bottom: 20px !important;
    }

    .margin-top-30 {
      margin-top: 20px !important;
    }

    .padding-top-10 {
      padding-top: 8px !important;
    }

    .margin-top-20 {
      margin-top: 15px !important;
    }

    .w-78 {
      width: 60px !important;
    }

    .h-78 {
      height: 60px !important;
    }

    .padding-top-85 {
      padding-top: 60px !important;
    }

    .padding-top-40 {
      padding-top: 25px !important;
    }

    .margin-bottom-12 {
      margin-bottom: 10px !important;
    }

    .padding-left-30 {
      padding-left: 20px !important;
    }
  }

  .menu-list {
    .w-162 {
      width: 130px !important;
    }

    .h-46 {
      height: 40px !important;
    }

    .margin-bottom-20 {
      margin-bottom: 15px !important;
    }

    .w-18 {
      width: 15px !important;
    }

    .h-22 {
      height: 18px !important;
    }

    .padding-left-12 {
      padding-left: 8px !important;
    }
  }

  .user-info {
    .text-bold {
      font-size: 14px !important;
    }

    .w-61 {
      width: 55px !important;
    }

    .h-26 {
      height: 23px !important;
    }

    .text-16 {
      font-size: 13px !important;
    }
  }

  ::v-deep .el-dialog {
    &__body {
      padding: 0 !important;
    }
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .left-menu {
    .padding-top-50 {
      padding-top: 20px !important;
    }

    .padding-bottom-30 {
      padding-bottom: 12px !important;
    }

    .margin-right-40 {
      margin-right: 8px !important;
    }

    .margin-top-30 {
      margin-top: 12px !important;
    }

    .padding-top-10 {
      padding-top: 4px !important;
    }

    .margin-top-20 {
      margin-top: 10px !important;
    }

    .w-78 {
      width: 40px !important;
    }

    .h-78 {
      height: 40px !important;
    }

    .padding-top-85 {
      padding-top: 30px !important;
    }

    .padding-top-40 {
      padding-top: 15px !important;
    }

    .margin-bottom-12 {
      margin-bottom: 6px !important;
    }

    .padding-left-30 {
      padding-left: 15px !important;
    }

    .w-206 {
      width: 100% !important;
    }
  }

  .menu-list {
    .w-162 {
      width: 90px !important;
    }

    .h-46 {
      height: 32px !important;
    }

    .margin-bottom-20 {
      margin-bottom: 10px !important;
    }

    .w-18 {
      width: 12px !important;
    }

    .h-22 {
      height: 14px !important;
    }

    .padding-left-12 {
      padding-left: 5px !important;
    }

    .menu-item {
      font-size: 11px !important;
    }

    .w-70 {
      width: 45px !important;
    }

    .h-70 {
      height: 45px !important;
    }

    .padding-top-10 {
      padding-top: 5px !important;
    }

    .text-white {
      font-size: 10px !important;
    }
  }

  .user-info {
    .text-bold {
      font-size: 10px !important;
    }

    .w-61 {
      width: 40px !important;
    }

    .h-26 {
      height: 18px !important;
    }

    .text-16 {
      font-size: 10px !important;
    }
  }

  .padding-top-30 {
    padding-top: 20px !important;
  }

  .padding-top-40 {
    padding-top: 15px !important;
  }

  .padding-left-30 {
    padding-left: 20px !important;
  }

  .text-32 {
    font-size: 18px !important;
  }
  .signin-container {
    padding: 0 15px !important;
    padding-bottom: 15px !important;
  }

  .signin-grid {
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr)) !important;
    gap: 10px !important;
  }

  .w-109 {
    width: 70px !important;
  }

  .h-188 {
    height: 120px !important;
  }

  .text-22 {
    font-size: 14px !important;
  }

  .icon-48 {
    width: 32px !important;
    height: 32px !important;
  }

  .icon-56 {
    width: 36px !important;
    height: 36px !important;
  }

  .text-24 {
    font-size: 12px !important;
  }

  .padding-top-10 {
    padding-top: 5px !important;
  }

  .custom-button-common-long {
    height: 40px !important;
    font-size: 14px !important;
  }

  .signin-button-container {
    padding: 15px 0 0 0 !important;
  }

  .text-999-color {
    font-size: 11px !important;
  }

  .radius-16 {
    border-radius: 10px !important;
  }

  ::v-deep .el-dialog {
    width: 90% !important;
    margin-top: 3vh !important;

    &__body {
      padding: 0 !important;
    }
  }
}

.user-info {
  .cursor-pointer {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }
}

.sign-entry-button {
  transition: all 0.3s ease;

  &.sign-entry-disabled {
    background: rgba(255, 255, 255, 0.3);
    cursor: not-allowed;
    color: rgba(255, 255, 255, 0.85);
  }
}

.menu-list {
  .menu-item {
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      transform: translateX(5px);
    }

    &.active {
      background-color: #fff;
      color: #2a4acc !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }
}

::v-deep {

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }

  .el-dialog {
    border-radius: 30px;
  }
}

.dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 80vh;
}

.scroll-view {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;

    &:hover {
      background: #555;
    }
  }
}

.scroll-y {
  overflow-y: auto;
  overflow-x: hidden;
}

.signin-container {
  padding: 0 30px;
  padding-bottom: 30px;
}

.signin-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(109px, 1fr));
  gap: 20px;
  justify-items: center;
}

.signin-button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0 0 0;
}

.custom-button-common-long {
  width: 100%;
  max-width: 100%;
  height: 53px;
  background: #2342c9;
  border-radius: 11px;
}

.active-sty {
  background: rgba(2, 154, 253, 0.1);
}
</style>
